import styled from "styled-components";

export const HeaderStyle = styled.div`
  position: relative;
  width: 100%;
  height: 97px;

  .hovered {
    .external {
      /* background-color: gold !important; */

      li {
        transition: 0.3s;
        transition-delay: 0.3s;
        opacity: 1;
        visibility: visible;
        color: #a7a7a7;
        a {
          cursor: pointer;
          &:hover {
            color: #000;
          }
        }
      }
    }
    .ar_ {
      transition-delay: 0s;
      transform: rotate(-135deg);

      path {
        transition-delay: 0s;
        stroke: #ffbc00;
      }
    }
  }

  @media ${(props) => props.theme.tablet} {
    ${(props) =>
      props.is_home
        ? `
            position: absolute;
            z-index: 99999;`
        : ""}
  }
`;

export const HeaderSection = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  z-index: 99999;
  width: 100%;
  background: #fff;
  height: 97px;
  // background: none;
  transition: 0.4s ease;
  &.hide {
    transform: translateY(-97px);
  }
  @media ${(props) => props.theme.tablet} {
    &.top {
      background: transparent;
    }
  }
`;

export const HeaderWrapper = styled.div`
  position: absolute;
  width: 100%;
  z-index: 3;
  box-sizing: border-box;
  height: 97px;
  padding-left: 50px;
  padding-right: 50px;

  /* overflow:hidden; */
  & > a {
    z-index: 100001;
    position: relative;
    display: block;
  }

  .shape {
    display: block;
    height: 0px;
    width: 100%;
    left: 0px;
    top: 87px;
    overflow: hidden;
    transition: 0.3s;
    position: absolute;

    &:after {
      content: "";
      display: block;
      width: 470px;
      height: 470px;
      position: absolute;
      left: -100px;
      top: -260px;
      background-image: url(${(props) =>
        props.theme.image_url}/common/star.png);
      z-index: 999;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      animation: rotation 8s infinite linear;
    }

    &:before {
      content: "";
      display: block;
      width: 270px;
      height: 270px;
      position: absolute;
      top: 200px;
      left: 600px;
      background-image: url(${(props) =>
        props.theme.image_url}/common/star_.png);
      z-index: 999;
      background-size: contain;
      background-position: center;
      background-repeat: no-repeat;
      /* animation: rotation 6s infinite linear; */
    }

    @keyframes rotation {
      from {
        -webkit-transform: rotate(0deg);
      }
      to {
        -webkit-transform: rotate(359deg);
      }
    }
  }

  &:after {
    margin-left: -50px;
    margin-right: -50px;
    display: block;
    transition: 0.3s;
    position: relative;
    content: "";
    // width: 100%;
    max-width: 200%;
    height: 0px;
    /* height: 350px; */
    top: 60%;
    left: 0px;
    background: #ffbc00;
    z-index: 99999;
    opacity: 1;
  }

  &:hover {
    transition: 0.3s;

    .shape {
      display: block;
      height: 340px;
    }

    .sub_ul {
      display: block;
      opacity: 1;
      height: auto;
      top: 130%;
    }

    &:after {
      transition: 0.3s;
      position: relative;
      content: "";
      // width: 100%;
      // TODO: 노랑 배경
      height: 340px;
      top: 18%;
      background: #ffbc00;
      z-index: 1;
    }

    .recruite {
      :after {
        transform: translate(0, 0);
      }
      transform: scale(1.05);
      transition: 0.2s;
    }
  }

  @media screen and (max-width: 1250px) {
    padding-left: 30px;
    padding-right: 30px;

    &:hover {
      .shape,
      &:after {
        height: 400px;
      }
    }
  }

  // width: 1024
  @media ${(props) => props.theme.tablet} {
    padding-left: 25px;
    padding-right: 25px;

    ${(props) =>
      props.is_home
        ? `
            position:absolute;
            top:0px;
            left:0px;
            width:100%;`
        : ""}
  }

  @media screen and (max-width: 900px) {
    padding-left: 0px;
    padding-right: 0px;

    & > a {
      z-index: 99999;
      position: relative;
      display: block;
    }

    .shape {
      display: none;
    }

    &:hover {
      .shape {
        display: none;
      }

      .sub_ul {
        display: none;
      }

      &:after {
        display: none;
      }
    }
  }
`;

export const Logo = styled.div`
  position: absolute;
  margin-top: 40px;
  margin-left: 0px;

  svg {
    width: 190px;
    height: auto;
  }

  @media ${(props) => props.theme.laptop} {
  }

  @media ${(props) => props.theme.tablet} {
    & svg {
      width: 169px;
      height: auto;
      g > path:not(:first-child) {
        ${(props) => (props.type == "white" ? `fill: #000;` : ``)}
      }
    }
    .top & svg {
      g > path:not(:first-child) {
        ${(props) => (props.type == "white" ? `fill: #fff;` : ``)}
      }
    }
  }

  @media screen and (max-width: 900px) {
    margin-left: 20px;
    margin-top: 36px;
  }
`;

export const HeaderMenu = styled.div`
  float: inherit;
  position: relative;
  z-index: 100000;
  // margin-top: 41px;
  text-align: center;
  & > ul {
    position: relative;
    z-index: 99999;
    display: inline-block;
    margin-top: 40px;
    & > li {
      float: left;
      padding: 0 71px;
      position: relative;
    }
    & > li > a {
      position: relative;
      font-family: "KBFG Display", sans-serif;
      font-style: normal;
      font-weight: 400;
      font-size: 18px;
      line-height: 25px;
      text-align: center;
      color: #1a1a1a;
      text-decoration: none;
      transition: 0.3s;
      :focus {
        outline: none;
      }
      :before {
        transition: 0.3s;
        display: block;
        position: absolute;
        content: "";
        background: #ffdc00;
        border-radius: 50%;
        height: 6px;
        width: 6px;
        left: 50%;
        margin-left: -3px;
        opacity: 0;
        bottom: 0px;
      }
    }
    &.sub > li > a,
    &:hover > li > a,
    &:hover .sub > li.active > a {
      color: #999;
    }

    &.sub > li.active > a,
    &:hover .sub > li.active:hover > a,
    &:hover > li:hover > a {
      color: #000;
      :before {
        display: block;
        position: absolute;
        content: "";
        background: #ffdc00;
        opacity: 1;
        bottom: -10px;
      }
    }

    &:hover .sub & > li.active:hover,
    &.sub & > li.active,
    & > li:hover {
    }

    &:hover .sub & > li.active {
      :before {
        display: block;
        position: absolute;
        content: "";
        background: #ffdc00;
        opacity: 0;
        bottom: 0px;
      }
    }
  }

  img {
    width: 18px;
    height: 18px;
    position: relative;
    bottom: 2px;
    margin-left: 10px;
  }

  .sub_ul {
    transition: 0.6s;
    position: absolute;
    opacity: 0;
    padding-top: 45px;
    width: 100%;
    height: 0px;
    overflow: hidden;
    text-align: center;
    left: 0px;
    top: 0px;
    z-index: 2;

    li {
      margin-bottom: 25px;
    }
    a {
      font-family: "KBFG Text";
      text-decoration: none;
      font-size: 15px;
      line-height: 20px;
      font-weight: normal;
      color: #333;
      transition: 0.4s;
      :hover {
        opacity: 0.7;
        text-decoration: underline;
        color: #333;
      }
    }
  }

  @media screen and (max-width: 1440px) {
    & > ul {
      & > li {
        padding: 0 58px;
      }
    }

    .sub_ul {
      z-index: 1000;
    }
  }

  @media screen and (max-width: 1250px) {
    & > ul {
      & > li {
        padding: 0 50px;
      }
    }
  }

  @media screen and (max-width: 1130px) {
    & > ul {
      & > li {
        padding: 0 40px;
      }
    }
  }

  // width: 1024
  @media ${(props) => props.theme.tablet} {
    & > ul {
      & > li {
        padding: 0 30px;
      }
    }

    .sub_ul {
      z-index: 1000;
    }

    .top & > ul {
      & > li > a {
        ${(props) => (props.header_type == "white" ? `color: #fff;` : ``)}
      }
      \ &.sub li a,
      &:hover li a,
      &:hover .sub li.active a {
        ${(props) => (props.header_type == "white" ? `color: #fff;` : ``)}
      }

      &.sub li.active a,
      &:hover .sub li.active:hover a,
      &:hover li:hover a {
        ${(props) => (props.header_type == "white" ? `color: #fff;` : ``)}
      }
    }
  }

  @media screen and (max-width: 900px) {
    margin-right: 20px;
    margin-top: 35px;

    ul {
      display: none;
    }
  }
`;

export const SearchToggle = styled.a`
  margin-top: 35px;
  display: inline-block;
  position: absolute;
  z-index: 30;
  right: 0px;
  path {
  }
  svg {
    width: 24px;
    height: 30px;
    cursor: pointer;
    margin-right: 5px;
  }

  @media ${(props) => props.theme.tablet} {
    /* right: 30px; */
    right: 0;
    .top & path {
      ${(props) => (props.search_type == "white" ? `fill: #fff;` : ``)}
    }
  }

  @media screen and (max-width: 900px) {
    right: 45px;
    margin-top: -4px;

    svg {
      height: 28px;
    }
  }
`;

export const ExternalLink = styled.div`
  position: absolute;
  top: 34px;
  /* right: 70px; */
  right: 140px;

  ul {
    display: inline-block;
  }

  li {
    float: left;
    opacity: 0;
    visibility: hidden;
  }

  li:after {
    display: inline-block;
    position: relative;
    content: "";
    border-radius: 50%;
    background: #c4c4c4;
    width: 3px;
    height: 3px;
    margin: 0 14px;
    top: 8px;
    vertical-align: top;
  }

  li:last-child:after {
    display: none;
  }

  a {
    font-family: "KBFG Display";
    font-style: normal;
    font-weight: 500;
    font-size: 15px;
    line-height: 19px;
    text-align: center;
    color: #a7a7a7;
    text-decoration: none;
    :focus {
      outline: none;
    }
  }

  /* a {
    border: 2px solid blue;
    &:hover {
      border: 2px solid red;

      li {
        transition: 0.3s;
        transition-delay: 0.3s;
        opacity: 1;
        visibility: visible;
      }
      border: 2px solid red;
    } */

  :hover {
    /* li {
      transition: 0.3s;
      transition-delay: 0.3s;
      opacity: 1;
      visibility: visible;
    } */
  }

  :not(:hover) {
    transition-delay: 0s;
  }

  @media ${(props) => props.theme.tablet} {
    /* right: 65px;            */
    right: 120px;

    a {
      font-size: 13px;
      ${(props) =>
        props.header_type == "white"
          ? `
            color: #000;
            i:before{
                background: transparent;
            }
            path{
                stroke: #fff;
            }
            `
          : ``}
    }

    li:after {
      background: #000;
    }
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const RecruitBtn = styled.a`
  position: absolute;
  top: 35px;
  right: 46px;
  display: inline-block;
  width: auto;
  transition: 0.2s;
  font-family: "KBFG Text";
  font-style: normal;
  font-weight: 600;
  font-size: 15px;
  line-height: 24px;
  text-align: center;
  color: #000;
  text-decoration: none;
  background: #fff;
  /* border: 1px solid #FFBC00; */
  border-radius: 40px;
  padding: 0 12px;
  line-height: 33px;
  height: 33px;

  transition: 0.2s;
  overflow: hidden;
  text-decoration: none;
  transition: 0.2s transform ease-in-out;
  z-index: 0;
  transform: scale(1);
  border: none;
  outline: none;

  :after {
    background-color: #ffbc00;
    border-radius: 3rem;
    content: "";
    display: block;
    height: 100%;
    width: 100%;
    position: absolute;
    left: 0;
    top: 0;
    transform: translate(-100%, 0) rotate(10deg);
    transform-origin: top left;
    transition: 0.2s transform ease-out;
    z-index: -1;
    outline: none;
  }

  :focus {
    outline: none;
  }

  /* :hover {
        :after{
            transform: translate(0, 0);
        }
        transform :scale(1.05);
        transition: 0.2s;
    } */

  @media ${(props) => props.theme.tablet} {
    right: 40px;
    font-size: 14px;
  }

  @media screen and (max-width: 900px) {
    display: none;
  }
`;

export const Hamburger = styled.div`
  display: none;
  position: relative;
  margin-right: 0px;
  float: right;
  /* position:fixed; */
  left: 0px;
  top: 0px;
  z-index: 999997;

  div {
    float: left;
    width: 30px;
    height: 20px;
    position: relative;
    cursor: pointer;

    & > i {
      border-radius: 1px;
      display: block;
    }
    & > .l {
      /* border: 1px solid white; */
      width: 100%;
      height: 2px;
      background: #000;
      position: absolute;
      top: 0px;
      transition: 0.3s;
    }
    & > i:last-child {
      bottom: 0px;
      top: auto;
      width: 70%;
    }
    & > .s {
      position: absolute;
      top: 5px;
      /* border: 1px solid #000; */
      width: 60%;
      height: 2px;
      margin-top: 4px;
      margin-bottom: 4px;
      background: #000;
      transition: 0.3s;
    }

    ${(props) => {
      if (props.isopen) {
        return `
                    & > .s {
                        display:none;
                    }
                    & > .l {
                        background:#000;
                        width: 150%;
                    }
                    & > i:first-child {
                        transform:rotate(-45deg);
                        top:10px;
                        left: -5px;
                        width: 100%;
                    }
                    & > i:last-child {
                        transform:rotate(45deg);
                        top:10px;
                        left: -5px;
                        bottom: auto;
                        width: 100%;
                    }
                `;
      } else {
        if (props.color == "white") {
          return `
                        @media ${(props) => props.theme.mobile} {
                            .top & > .s,
                            .top & > .l {
                                background: #fff;
                            }

                        }
                    `;
        }
      }
    }}
  }

  @media screen and (max-width: 900px) {
    display: block;
    margin-left: 20px;
  }
`;

export const SideMenu = styled.div`
  width: 100%;
  height: 100%;
  transition: 0.4s;
  position: fixed;
  top: 0px;
  padding: 100px 70px;
  z-index: 99999;
  background: #fff;
  box-sizing: border-box;

  ${(props) => {
    if (props.isopen) {
      return `
                right:0px;
            `;
    } else {
      return `
                right:-400px;
            `;
    }
  }}

  ul {
    li {
      position: relative;
      margin-bottom: 30px;

      :before {
        transition: 0.3s;
        display: block;
        position: absolute;
        content: "";
        background: #ffdc00;
        border-radius: 50%;
        height: 6px;
        width: 6px;
        left: 50%;
        margin-left: -3px;
        opacity: 0;
        top: -15px;
        left: -3px;
      }
    }

    a {
      position: relative;
      font-family: "KBFG Display", sans-serif;
      font-style: normal;
      font-weight: 500;
      font-size: 35px;
      line-height: 45px;
      text-align: center;
      color: #1a1a1a;
      text-decoration: none;
      transition: 0.3s;
      :focus {
        outline: none;
      }
    }

    .acc {
      margin-top: 30px;
    }

    .a-cc {
      position: relative;
      top: 20px;
      padding-bottom: 20px;
    }

    .acc:last-child {
      margin-top: 30px;
    }

    .acc a {
      font-size: 20px;
      line-height: 20px;
      color: #666;
    }

    .sub li a,
    &:hover li a,
    &:hover .sub li.active a {
      color: #999;
    }

    .sub li.active a,
    &:hover .sub li.active:hover a,
    &:hover li:hover a {
      color: #000;
    }

    &:hover .sub li.active:hover,
    .sub li.active,
    li:hover {
      :before {
        display: block;
        position: absolute;
        content: "";
        background: #ffdc00;
        opacity: 1;
        top: -3px;
      }
    }

    &:hover .sub li.active {
      :before {
        display: block;
        position: absolute;
        content: "";
        background: #ffdc00;
        opacity: 0;
        bottom: 0px;
      }
    }
  }

  ${(props) => (props.isopen ? `display:block` : `display:none`)}
`;

export const SearchBarWrapper = styled.div``;

export const SearchBar = styled.div`
  width: 100%;
  height: 210px;
  position: fixed;
  transition: 0.5s ease;
  padding-top: 70px;
  text-align: center;
  background: #fff;
  box-sizing: border-box;
  z-index: 99999;
  ${(props) => {
    if (props.searchopen) {
      return `
                top: 0px;
            `;
    } else {
      return `
                top: -500px;
            `;
    }
  }}
  input {
    position: relative;
    font-family: "KBDS Display";
    font-size: 20px;
    font-weight: 600;
    color: #000;
    transition: 0.7s ease;
    width: 60%;
    height: 50px;
    border: none;
    border-bottom: 4px solid #ffdc00;
    ${(props) => {
      if (props.searchopen) {
        return `
                    width: 60%;
                `;
      } else {
        return `
                    width: 20%;
                `;
      }
    }}
  }
  & > div {
    display: block;
    position: absolute;
    width: 20px;
    height: 20px;
    top: calc(50% - 20px);
    right: 20%;
    cursor: pointer;
    div:nth-of-type(1) {
      display: inline-block;
      transform: rotate(45deg);
      background: #000;
      width: 2px;
      height: 100%;
      margin-right: -2px;
    }
    div:nth-of-type(2) {
      display: inline-block;
      transform: rotate(-45deg);
      background: #000;
      width: 2px;
      height: 100%;
    }
  }
  input::placeholder {
    position: relative;
    font-family: "KBDS Display";
    font-size: 20px;
    font-weight: 600;
    color: #000;
  }
  @media ${(props) => props.theme.mobile} {
    input {
      ${(props) => {
        if (props.searchopen) {
          return `
                        width:80%;
                    `;
        } else {
          return `
                        width: 20%;
                    `;
        }
      }}
    }
    & > div {
      right: 10%;
    }
  }
`;

export const Overlay = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.4);
  z-index: 100;
  top: 0px;
  left: 0px;
  ${(props) => {
    if (props.searchopen) {
      return `
                display:block;
            `;
    } else {
      return `
                display:none;
            `;
    }
  }}
`;
